/**
 * Builds the default report display name from customer and reporting period.
 * @param params - Customer label and composed reporting period.
 * @returns Default name such as `Acme Health: Apr 2026`.
 */
export const buildDefaultReportName = (params: {
  customerName: string;
  reportingPeriod: string;
}): string =>
  `${params.customerName.trim()}: ${params.reportingPeriod.trim()}`;

/**
 * Returns true when the report name matches the auto-generated default.
 * @param params - Stored name plus customer and formatted measurement period labels.
 */
export const matchesDefaultReportName = (params: {
  name: string;
  customerName: string;
  measurementPeriodLabel: string;
}): boolean => {
  if (!params.measurementPeriodLabel.trim()) {
    return false;
  }
  const defaultName = buildDefaultReportName({
    customerName: params.customerName,
    reportingPeriod: params.measurementPeriodLabel,
  });
  return params.name.trim() === defaultName.trim();
};
